import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  print(event) {
    event.preventDefault()

    if (this.hasUrlValue) {
      this.printUrl(this.urlValue)
    } else {
      window.print()
    }
  }

  printUrl(url) {
    const printWindow = window.open(url, "_blank")
    if (!printWindow) return

    printWindow.addEventListener("load", () => {
      printWindow.focus()
      setTimeout(() => printWindow.print(), 250)
    })
  }
}
